import config from 'config';
import { EventNotifier, FaviconMarker, SoundMarker } from '@mssgme/services';

// TODO: remove, create components
export class InboxEventNotifier extends EventNotifier {
    constructor() {
        super([
            // new FaviconMarker('/favicon_dot32.png', 'link[data-icon="fav16"]'),
            new FaviconMarker('/favicon_dot32.png', 'link[data-icon="fav32"]'),
            // new FaviconMarker('/favicon_dot32.png', 'link[data-icon="favIco"]'),
            new SoundMarker(
                [
                    `${config.statics_url}/webapp-legacy/sound/inbox.ogg`,
                    `${config.statics_url}/webapp-legacy/sound/inbox.mp3`,
                    `${config.statics_url}/webapp-legacy/sound/inbox.wav`,
                ],
                { duration: 4000 }
            ),
        ]);
    }
}
